import { CompanyInfoPublic } from "apps/companies/models/company"
import ApiService from "services/api";

export class JobOffer {

    constructor(data){

        this.id                             = data.id
        this.title                          = data.title
        this.slug                           = data.slug
        this.qualification_category1        = data.qualification_category1
        this.qualification_category2        = data.qualification_category2
        this.qualification_category2_data   = data.qualification_category2_data
        this.description                    = data.description
        this.vacancy                        = data.vacancy
        this.contract_type                  = data.contract_type
        this.contract_type_data             = data.contract_type_data
        this.contract_start_date            = data.contract_start_date
        this.expire_date                    = data.expire_date
        this.contract_duration              = data.contract_duration
        this.min_age                        = data.min_age
        this.max_age                        = data.max_age
        this.experience_level               = data.experience_level
        this.experience_level_data          = data.experience_level_data
        this.city                           = data.city
        this.city_data                      = data.city_data
        this.province                       = data.province
        this.province_data                  = data.province_data
        this.address                        = data.address
        this.language1                      = data.language1
        this.language1_data                 = data.language1_data
        this.language2                      = data.language2
        this.language2_data                 = data.language2_data
        this.language3                      = data.language3
        this.language3_data                 = data.language3_data
        this.professional_order             = data.professional_order
        this.professional_order_data        = data.professional_order_data
        this.register                       = data.register
        this.register_data                  = data.register_data
        this.license                        = data.license
        this.license_data                   = data.license_data
        this.education                      = data.education
        this.education_data                 = data.education_data
        this.contact_mode                   = data.contact_mode
        this.company                        = new CompanyInfoPublic(data.company_data || {})  
        this.created_date                   = data.created_date  
    }    

    // Check if the user is the owner of the job offer
    async isOwner() {        
        let result = await ApiService.checkJobOfferOwner(this.slug);
        if(result.length > 0){
            return true;
        }
        return false;
    }

    // Check if the user has already applied to the job offer
    async checkAlreadyApplied() {
        let result = await ApiService.getJobApplicationByJobOffer(this.id);
        if(result.length > 0){
            return true;
        }
        return false;
    }

    // Check if the user has bookmarked the job offer
    async checkBookmark() {
        let result = await ApiService.getBookmarkedOfferByJobOffer(this.id);
        return result;
    }

    // Check if the offer is expired
    isExpired() {
        let result = new Date(this.expire_date) < new Date()
        return result;
    }
}